import React from "react";
import { Icon } from "../util/Icon";
import { useNavigate } from "react-router-dom";

function UpdateDeleteBar({ onDelete, onSave, title }) {
  const navigate = useNavigate();

  return (
    <div className="border-bottom bg-white px-4 py-2 d-flex align-items-center gap-3 sticky-top">
      <button
        onClick={() => navigate(-1)}
        type="button"
        className="btn btn-outline-secondary btn-sm"
        aria-label="back"
      >
        <Icon iconName="ArrowLeft" aria-hidden="true" />
      </button>
      {title && (
        <h6 className="mb-0 fw-semibold text-truncate flex-grow-1" style={{ maxWidth: "60%" }}>
          {title}
        </h6>
      )}
      <div className="d-flex gap-2 ms-auto">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={onSave}
        >
          <Icon iconName="Save" className="me-1" aria-hidden="true" />
          Save
        </button>
        <button
          type="button"
          className="btn btn-outline-danger btn-sm"
          onClick={onDelete}
        >
          <Icon iconName="Trash" className="me-1" aria-hidden="true" />
          Delete
        </button>
      </div>
    </div>
  );
}

export default UpdateDeleteBar;
